"use client";

import { IAnanlyticsCompactProduct } from "api/interfaces/get-page-details/common/CompactProduct.type";
import { RootState } from "interfaces/generics.type";
import { getOrCreateStore } from "modules/lib/with-redux-store";

export default function sendUETAddToCartEvent(product: IAnanlyticsCompactProduct) {
  if (!window.uetq) {
    return;
  }
  const store: RootState = getOrCreateStore().getState();
  const { currentPageType } = store.utils;
  const price = (product.price / 100) * (product.quantity || 1);
  window.uetq.push("event", "add_to_cart", {
    ecomm_prodid: product.sku,
    ecomm_pagetype: currentPageType?.toLowerCase().includes("product") ? "product" : "category",
    ecomm_totalvalue: price,
    revenue_value: price,
    currency: "CAD",
    items: [{
      id: product.sku,
      quantity: product.quantity,
      price: product.price / 100,
    }],
  });
}
